import PropTypes from 'prop-types';

export const MessageFieldType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  intent: PropTypes.number,
  entity: PropTypes.number,
  entityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  field: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  entityLabel: PropTypes.string,
});

export const MessageFileType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  intent: PropTypes.number,
  documentType: PropTypes.string,
  file: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    filename: PropTypes.string,
    extension: PropTypes.string,
    deleted: PropTypes.bool,
  }),
});

export const MessageAttachmentType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  displayName: PropTypes.string,
  downloadUrl: PropTypes.string,
  file: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    filename: PropTypes.string,
    extension: PropTypes.string,
    deleted: PropTypes.bool,
  }),
});

export const MessageType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  timestamp: PropTypes.string.isRequired,
  message: PropTypes.string,
  sender: PropTypes.number.isRequired,
  senderLabel: PropTypes.string,
  fields: PropTypes.arrayOf(MessageFieldType),
  files: PropTypes.arrayOf(MessageFileType),
  attachments: PropTypes.arrayOf(MessageAttachmentType),
});

export const TaskDetailType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  messages: PropTypes.arrayOf(MessageType),
  lastMessage: MessageType,
});
